// ============================================================
// sale-content/BackgroundSection.js — ภาพพื้นหลังเว็บไซต์ (section "background")
// ------------------------------------------------------------
// ย้ายมาจากหน้า sale-page-contents.js เดิม พฤติกรรมเหมือนเดิมทุกอย่าง
//   - ใส่ได้หลายภาพ (เลือกหลายไฟล์พร้อมกัน) หน้าเว็บเล่นวนเป็นสไลด์ตามลำดับ
//   - ปิด "แสดง" = ข้ามภาพนั้นทันทีโดยไม่ต้องลบ
//   - เลื่อนลำดับ / ลบ (ยืนยันผ่าน modal ของหน้าแม่)
// ★ ของกลางทั้งเว็บ (project_id = null) — ไม่ว่าเลือกโครงการไหนอยู่ก็เห็นชุดเดียวกัน
// ★ ไฟล์นี้ไม่ยิง API เอง หน้าแม่เป็นคนอัปโหลด/บันทึก
// ============================================================

import React from "react";

export default function BackgroundSection({ items = [], uploading, working, onPick, onMove, onToggle, onDelete }) {
  const active = items.filter((i) => i.is_active);
  const openPicker = () => document.getElementById("bg-image-input").click();

  return (
    <div className="prop-card prop-in">
      <div className="prop-card__head">
        <span className="prop-title text-16">
          <span className="prop-title__dot" />
          ภาพพื้นหลังเว็บไซต์
        </span>
        <div>
          <input hidden accept="image/*" id="bg-image-input" type="file" multiple onChange={onPick} />
          <button type="button" className="prop-btn prop-btn--sm" disabled={uploading} onClick={openPicker}>
            <span className="icon text-12">{""}</span> {uploading ? "กำลังอัปโหลด..." : "เพิ่มภาพ"}
          </button>
        </div>
      </div>

      <div className="p-4">
        <div className="row g-3 mb-3">
          <div className="col-6 col-md-4 col-xl-3">
            <div className="project-room-sales-stat">
              <small>ภาพทั้งหมด</small>
              <strong>{items.length}</strong>
            </div>
          </div>
          <div className="col-6 col-md-4 col-xl-3">
            <div className="project-room-sales-stat available">
              <small>ใช้เป็นสไลด์</small>
              <strong>{active.length}</strong>
            </div>
          </div>
          <div className="col-6 col-md-4 col-xl-3">
            <div className="project-room-sales-stat unregistered">
              <small>ซ่อนไว้</small>
              <strong>{items.length - active.length}</strong>
            </div>
          </div>
        </div>

        <div className="pf-hint mb-3">
          ใส่ได้หลายภาพ — หน้าเว็บจะเล่นวนเป็นสไลด์ตามลำดับด้านล่าง · แนะนำภาพแนวนอน กว้าง 1920 px ขึ้นไป
          {active.length === 1 ? " · มีภาพเดียวจะแสดงเป็นภาพนิ่ง" : ""}
          {active.length === 0 ? " · ยังไม่มีภาพที่เปิดใช้ หน้าเว็บจะเป็นพื้นขาว" : ""}
        </div>

        {!items.length ? (
          <div
            className="w-100 py-5 d-flex align-items-center justify-content-center border border-secondary border-2 border-dash rounded-3 pointer"
            onClick={openPicker}
          >
            <div className="text-center">
              <div className="icon text-40 text-secondary">{""}</div>
              <div className="text-secondary">เลือกภาพพื้นหลัง (เลือกได้หลายไฟล์)</div>
            </div>
          </div>
        ) : (
          <div className="row g-3">
            {items.map((item, index) => (
              <div className="col-12 col-md-6 col-xl-4" key={item.uid}>
                <div className={`border rounded-4 overflow-hidden h-100 ${item.is_active ? "" : "opacity-50"}`}>
                  <div className="position-relative" style={{ background: "#f1f3f7" }}>
                    <img
                      src={item.image_url}
                      alt={item.title || `ภาพที่ ${index + 1}`}
                      style={{ width: "100%", height: 180, objectFit: "cover", display: "block" }}
                    />
                    <span
                      className="position-absolute bg-dark text-white rounded-pill px-3 py-1 text-12"
                      style={{ left: 10, top: 10, opacity: 0.85 }}
                    >
                      ลำดับ {index + 1}
                    </span>
                    <span
                      className={`position-absolute rounded-pill px-3 py-1 text-12 text-white ${item.is_active ? "bg-success" : "bg-secondary"}`}
                      style={{ right: 10, top: 10 }}
                    >
                      {item.is_active ? "แสดง" : "ซ่อน"}
                    </span>
                  </div>

                  <div className="p-3">
                    <div className="text-truncate mb-2">{item.title || "-"}</div>
                    <div className="d-flex flex-wrap gap-2">
                      <button
                        type="button"
                        className="prop-btn prop-btn--ghost prop-btn--sm"
                        title="เลื่อนขึ้น"
                        disabled={index === 0 || !!working}
                        onClick={() => onMove(index, -1)}
                      >
                        <span className="icon">{""}</span>
                      </button>
                      <button
                        type="button"
                        className="prop-btn prop-btn--ghost prop-btn--sm"
                        title="เลื่อนลง"
                        disabled={index === items.length - 1 || !!working}
                        onClick={() => onMove(index, 1)}
                      >
                        <span className="icon">{""}</span>
                      </button>
                      <button
                        type="button"
                        className="prop-btn prop-btn--ghost prop-btn--sm"
                        disabled={!!working}
                        onClick={() => onToggle(item)}
                      >
                        {item.is_active ? "ซ่อน" : "แสดง"}
                      </button>
                      <button
                        type="button"
                        className="prop-btn prop-btn--danger prop-btn--sm ms-auto"
                        disabled={!!working}
                        onClick={() => onDelete(item)}
                      >
                        ลบ
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
